import { loadBlock, loadVendor } from './utils/theme';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';

window.app = window.app || {};
var app = window.app;
var locationHash = typeof preLocationHash !== 'undefined' ? preLocationHash : window.location.hash;

const webSiteWrapperSelector = '.wp-site-blocks';

window.app.clear = {
	hash: hash => `#${ hash.replace( /#/gi, '' ) }`,
	path: path => path.replace( /\/*$/, '' )
};

/**
 * @param $tagLink - jQuery <a href=""> tag
 * @param link - Link href
 * @returns {{type: string, hash: string}}
 *
 * @args type:
 *      'hash-modal' - This tag for modal
 *      'hash-this-page' - This page link with hash
 *      'hash-another-page-here' - Another page link with hash block in current page
 *      'hash-another-page' - Another page link with hash without block in current page
 */
window.app.tagLinkValidator = ( $tagLink, link = $tagLink.attr( 'href' ) ) => {
	const pageUrl = new URL( window.location.href );
	let hash;
	let type; let linkUrl;

	if ( $tagLink.attr( 'data-toggle' ) === 'modal' ) {
		return {
			type: 'hash-modal',
			hash: link
		};
	}

	const defineLink = () => {
		try {
			linkUrl = new URL( link, pageUrl.origin );
		} catch ( error ) { // eslint-disable-line no-unused-vars
			linkUrl = link;
		}
	};

	const handleLinkPath = () => {
		if ( pageUrl.pathname === linkUrl.pathname ) {
			if ( linkUrl.hash ) {
				type = 'hash-this-page';
				hash = window.app.clear.hash( linkUrl.hash );
			}
		} else {
			if ( linkUrl.hash ) {
				hash = window.app.clear.hash( linkUrl.hash );

				if ( $( hash ).length ) {
					type = 'hash-another-page-here';
				} else {
					type = 'hash-another-page';
				}
			}
		}
	};

	defineLink();
	handleLinkPath();

	return {type, hash};
};


const hashMover = () => {
	locationHash = window.app.clear.hash( locationHash );

	if ( locationHash ) {

		if ( $( locationHash ).hasClass( 'modal' ) && !$( locationHash ).hasClass( 'js-modal-form' ) ) {
			return;
		} else if ( $( locationHash ).hasClass( 'js-modal-form' ) ) {
			$( locationHash ).modal( 'show' );
		} else {
			hashMoverHelper( locationHash );
		}

		window.location.hash = locationHash;
	}
};

const hashMoverHelper = ( locationHash ) => {
	let hashSection = $( locationHash ).length ? $( locationHash ) : $( `*[data-hash="${ locationHash }"]` );
	let adminPanel = $( '#wpadminbar' );
	let adminBar = 0;

	$( 'body' ).removeClass( 'no-scroll' );
	$( '.main-menu' ).removeClass( 'active' );
	$( '.main-menu-overlay' ).css( 'display', 'none' );
	$( '.page-header .page-header__menu-button' ).removeClass( 'active' );

	if ( adminPanel.length )
	{adminBar = adminPanel.outerHeight();}

	let headerHeight = $( '.page-header' ).outerHeight() + adminBar;

	if ( hashSection.length ) {
		let hashSectionPosition = hashSection[0].getBoundingClientRect();
		let distanceTop = hashSectionPosition.top + $( webSiteWrapperSelector )[0].scrollTop - headerHeight;

		if ( Math.ceil( $( webSiteWrapperSelector )[0].scrollTop ) === Math.floor( distanceTop ) )
		{return;}

		$( 'a[href]' ).each( function() {
			if ( $( this ).attr( 'href' ).indexOf( locationHash ) )
			{$( this ).css( 'data-hashActive', 'process' );}
		} );

		$( webSiteWrapperSelector ).animate( { scrollTop: distanceTop }, 1000, 'swing', () => {
			$( 'a[href]' ).each( function() {
				if ( $( this ).attr( 'href' ).indexOf( locationHash ) )
				{$( this ).attr( 'data-hashActive', '' );}
			} );
		} );
	}
};

class FontAdjustment {
	constructor( {el, rem, maxTitleLength, fj, fjSizeFactor = 2} ) {
		if ( el ) {this.setElement( el );}
		if ( rem ) {this.rem = rem;}
		if ( maxTitleLength ) {this.setMaxLength( maxTitleLength );}
		if ( fj ) {this.min = fj;}
		this.sizeFactor = fjSizeFactor;
		this.reinit();
		this.resize();
	}

	setElement( element ) {
		this._element = element;
	}

	setMaxLength( maxTitleLength ) {
		this._maxTitleLength = maxTitleLength;
	}

	reinit() {
		if ( !this._element.length ) {return;}
		this._element.forEach( elem => elem.style.fontSize = null );
		// this.defaultFont = this._element.
		this.style = window.getComputedStyle( this._element[0] );
		this.fontSizeDefaultPx = parseInt( this.style.fontSize, 10 );
	}

	resize() {
		this.fontSizePx = this.mapRange( this.fontSizeDefaultPx, 0, Math.max( this.min, this._maxTitleLength ), 0, this.min );

		let result = '';
		const docFontSize = parseFloat( getComputedStyle( document.documentElement ).fontSize );
		const px = Math.max( this.fontSizePx, ( docFontSize * this.sizeFactor ) );
		if ( this.rem ) {
			result = ( px / docFontSize ) + 'rem';
		} else {
			result = px + 'px';
		}
		this._element.forEach( elem => elem.style.fontSize = result );
	}

	mapRange( value, low1, high1, low2, high2 ) {
		return low2 + ( high2 - low2 ) * ( value - low1 ) / ( high1 - low1 );
	}
}

app.options = {
	breakpointMobile: 768,
	breakpointTablet: 1280,
	winW: document.documentElement.clientWidth,
	winH: window.innerHeight,
	isMobile: false,
	isTablet: false,
	isBlockEditor: $( 'body' ).hasClass( 'block-editor-page' ),
	youtubeIframeAPIInit: false,
	currentYoutubeVideoId: '',
	currentLocalVideoSrc: '',
	currentLocalVideoPoster: '',
	firstScriptElement: null,
	youtubeVideoIdOnApiInit: '',
};

app.main = {
	slugify: function( str ) {
		return String( str )
			.normalize( 'NFKD' )
			.replace( /[\u0300-\u036f]/g, '' )
			.trim()
			.toLowerCase()
			.replace( /[^a-z0-9 -]/g, '' )
			.replace( /\s+/g, '-' )
			.replace( /-+/g, '-' );
	},
	delayLoadScrypt: function( src, delay, callback = null ) {
		/** @var {HTMLElement} **/
		setTimeout( () => {
			if ( !app.options.firstScriptElement ) {app.options.firstScriptElement = document.getElementsByTagName( 'script' )[0];}
			const script = document.createElement( 'script' );
			script.src = src;
			script.onload = callback;
			app.options.firstScriptElement.parentNode.insertBefore( script, app.options.firstScriptElement );
			app.options.firstScriptElement = script;
		}, delay );
	},

	addButtonStyle: function() {
		if ( typeof buttonSettings.button_style !== 'undefined' && buttonSettings.button_style ) {
			document.querySelector( 'body' ).classList.add( buttonSettings.button_style );
		}
	},

	nonClickableSpans: function() {
		let spans = document.querySelectorAll( '.parent-menu-item-arrow' );

		spans.forEach( function( span ) {
			span.addEventListener( 'click', function( event ) {
				event.preventDefault();
			} );
		} );
	},

	checkIfYoutubeApiReady: function() {
		const next = () => {
			setTimeout( () => {
				if ( app.options.youtubeIframeAPIInit ) {return;}

				if ( ( typeof YT === 'undefined' ) || ( typeof YT.Player === 'undefined' ) ) {
					next();
				} else {
					app.options.youtubeIframeAPIInit = true;
					app.main.createYouTubePlayer();

				}
			}, 500 );
		};
		next();
	},
	createYouTubePlayer: function() {
		app.player = new YT.Player( 'modal-video-player', {
			height: '100%',
			width: '100%',
			playerVars: {
				'playsinline': 1,
				'origin': location.hostname
			},
			events: {
				'onReady': function() {
					app.main.initYoutube( app.options.youtubeVideoIdOnApiInit );
					$( 'button.js-btn-play-video-youtube' ).removeAttr( 'disabled' );
				}
			}
		} );
	},
	initYoutube: function( videoId ) {
		setTimeout( () => {
			app.main.addIdToYoutubePlayer( videoId );
		}, 0 );
	},
	addIdToYoutubePlayer: function( videoId ) {
		if ( !videoId || !app.player.loadVideoById ) {return;}
		app.player.loadVideoById( {
			videoId: videoId,
			origin: location.hostname,
		} );
		app.options.currentYoutubeVideoId = videoId;
		app.player.playVideo();

	},
	initVideoPopups: function() {
		$( document ).ready( function() {
			let $modalVideoYoutube = $( '#modal-video-youtube' );
			let $modalVideoLocal = $( '#modal-video-local' );

			function openYoutubeVideoPopup( element ) {
				let $element = $( element );
				let youtubeVideoId = $element.attr( 'data-youtube-id' );
				$modalVideoYoutube.modal( 'show' );
				if ( app.options.currentYoutubeVideoId === youtubeVideoId && youtubeVideoId !== '' ) {
					app.player.playVideo();
					return;
				}

				if ( youtubeVideoId ) {
					app.options.youtubeVideoIdOnApiInit = youtubeVideoId;
					if ( !app.player ) {
						app.main.checkIfYoutubeApiReady( youtubeVideoId );
						return;
					}
					app.main.addIdToYoutubePlayer( youtubeVideoId );
				}
			}

			function openLocalVideoPopup( element ) {
				let $element = $( element );
				let selfHostedVideo = $element.attr( 'data-local-video-src' );
				let selfHostedVideoPoster = $element.attr( 'data-local-video-poster' );
				let video = $modalVideoLocal.find( 'video' );
				$modalVideoLocal.modal( 'show' );
				if ( app.options.currentLocalVideoPoster !== selfHostedVideoPoster && selfHostedVideoPoster !== '' ) {
					video.attr( 'poster', selfHostedVideoPoster );
					app.options.currentLocalVideoPoster = selfHostedVideoPoster;
				}
				if ( app.options.currentLocalVideoSrc === selfHostedVideo && selfHostedVideo !== '' ) {
					video.first().trigger( 'play' );
					return;
				}
				video.attr( 'src', selfHostedVideo );
				app.options.currentLocalVideoSrc = selfHostedVideo;
				video.first().trigger( 'play' );
			}

			$( 'body' ).on( 'click', '.js-btn-play-video-youtube', function( event ) {
				event.preventDefault();
				openYoutubeVideoPopup( $( this ) );
			} );

			$( 'body' ).on( 'click', '.js-btn-play-video-local', function( event ) {
				event.preventDefault();
				openLocalVideoPopup( $( this ) );
			} );

			$( '.modal-video' ).on( 'hide.bs.modal', function() {
				var modal = $( this );

				if ( modal.find( 'video' ).length ) {
					modal.find( 'video' ).first().trigger( 'pause' );
				}

				if ( modal.find( '.js-youtube-player' ).length && app.player ) {
					app.player.stopVideo();
				}
			} );
		} );
	},
	successfullInitPage: function() {
		let wasInit = false;

		return () => {
			if ( wasInit ) {return;}
			wasInit = true;
			const differedScriptsLoading = () => {
				if ( typeof themeVars !== 'undefined' && themeVars.differed_script_load ) {
					for ( let key in themeVars.differed_script_load ) {
						const scryptData = themeVars.differed_script_load[key];
						app.main.delayLoadScrypt( scryptData.src, scryptData.delay || 0 );
					}
				}
			};

			app.main.checkIfYoutubeApiReady();

			differedScriptsLoading();
		};
	}(),
	locationHashCheck: function() {
		if ( locationHash ) {
			if ( $( locationHash ).hasClass( 'js-modal-form' ) && $( locationHash ).hasClass( 'modal' ) ) {
				$( locationHash ).modal( 'show' );
			}

		}

	},
	loadLazyLoadedVideos: function() {
		$( 'video source' ).each( function() {
			if ( !$( this ).attr( 'data-src' ) ) {
				return;
			}

			let $videoElement = $( this ).parent();

			if ( !$videoElement.length ) {
				return;
			}

			$videoElement.attr( 'poster', $videoElement.attr( 'data-poster' ) );
			$( this ).attr( 'src', $( this ).attr( 'data-src' ) );
			$videoElement[0].load();
		} );
	},
	parentStylesAdd: function() {
		let headerWrap = $( '.page-header ' ).parents( '.wp-block-template-part' );
		let footerWrap = $( '.page-footer ' ).parents( '.wp-block-template-part' );

		if ( headerWrap.length ) {
			headerWrap.addClass( 'page-header-wrap' );
		}

		if ( footerWrap.length ) {
			footerWrap.addClass( 'page-footer-wrap' );
		}
	},
	hideFocusOnDesktop: function() {
		$( 'a, button, input[type="checkbox"], input[type="radio"]' ).on( 'mouseup, mouseleave', function() {
			$( this ).blur();
		} );

		$( '.modal' ).on( 'show.bs.modal', function( event ) {
			let button = $( event.relatedTarget );
			let modal = $( this );

			modal.on( 'hidden.bs.modal', function() {
				setTimeout( function blur() {
					button.blur();
				}, 50 );
			} );
		} );
	},
	showModalFormEvent: function() {
		$( '.modal' ).on( 'show.bs.modal shown.bs.modal', function() {
			let $modalWrapper = $( this ).find( '.modal-form-wrapper' );

			if ( !$modalWrapper.length ) {
				return;
			}

			let formDetailsHolderClass = 'section-form-details-wrapper';
			$modalWrapper.find( '.' + formDetailsHolderClass ).remove();
			let $title = $modalWrapper.find( '.form-title-wrapper' );
			let $description = $modalWrapper.find( '.form-description-wrapper' );

			if ( $title ) {
				let titleHtml = '';
				let descriptionHtml = '';

				if ( $title.length ) {
					titleHtml = $title.parent().html();
				}

				if ( $description.length ) {
					descriptionHtml = $description.parent().html();
				}

				$modalWrapper.prepend( '<div class="' + formDetailsHolderClass + ' nf-form-cont">' + titleHtml + descriptionHtml + '</div>' );
			}
		} );
	},
	selectFormModalOption: function() {
		$( '.modal' ).on( 'show.bs.modal', function( event ) {
			let dataFormSelection = $( event.relatedTarget ).attr( 'data-form-selection' );

			if ( !dataFormSelection ) {
				return;
			}

			let $pricingSelection = $( this ).find( '.pricing-selection' );

			if ( !$pricingSelection.length ) {
				return;
			}

			let $selectField = $pricingSelection.find( 'select' );

			if ( $selectField && $selectField.find( 'option[value="' + dataFormSelection + '"]' ).length ) {
				$selectField.val( dataFormSelection ).change();
				return;
			}

			$selectField.val( $selectField.find( 'option' ).eq( 0 ).val() ).change();
		} );
	},
	resizeDependent: function() {
		app.options.isMobile = ( window.matchMedia( 'screen and (max-width: 767.5px)' ).matches );
		app.options.isTablet = ( ( window.matchMedia( 'screen and (max-width: 1279.5px)' ).matches ) && ( window.matchMedia( 'screen and (min-width: 768px)' ).matches ) );
		app.main.disableScrollRestoration();
		// app.main.horizontalScroll();

		if ( $( '.sidebar--mobile' ).length && app.options.isMobile ) {
			$( '.sidebar--mobile' ).find( '.collapse-panel__body' ).collapse( 'hide' );
			$( '.sidebar--mobile' ).find( '.collapse-panel__toggler' ).addClass( 'collapsed' ).attr( 'aria-expanded', false );
		}

		$( webSiteWrapperSelector ).scroll();
	},
	dynamicHashMenu: function() {
		if ( !$( 'body' ).hasClass( 'landing-page' ) )
		{return;}

		if ( !$( 'body' ).hasClass( 'home' ) )
		{return;}

		const $webSiteMainWrapper = $( webSiteWrapperSelector );
		const $headerMenuLinks = $( '.page-header .menu a' );
		const $mainMenuLinks = $( '.main-menu .menu a' );
		const debug = false;
		let controllableMenu = [];

		// Tools ---
		const fillMenus = $elements => {
			let output = [];

			$elements.each( function() {
				const $this = $( this );
				const href = $this.attr( 'href' );
				const validationResult = window.app.tagLinkValidator( $this );
				let link;

				try {
					link = window.app.clear.hash( new URL( href ).hash );
				} catch ( error ) { // eslint-disable-line no-unused-vars
					link = window.app.clear.hash( href );
				}

				if (
					validationResult.type === 'hash-this-page' ||
                    validationResult.type === 'hash-another-page-here'
				) {
					let $section = $( validationResult.hash );

					if ( $section.length ) {
						output.push( {
							link,
							$linkParent: $this.parent(),
							$section: $( validationResult.hash )
						} );
					} else {
						console.warn( {
							warning: `Section with hash - ${validationResult.hash} not found.`,
							func: 'dynamicHashMenuResizeable',
							solution: 'Try changing the section hash in the WordPress->Appearance->Menus'
						} );
					}
				}
			} );

			return output;
		};

		const clearActiveElementAll = () => {
			$headerMenuLinks.each( function() {
				$( this ).parent().removeClass( 'current-menu-item active' );
			} );

			$mainMenuLinks.each( function() {
				$( this ).parent().removeClass( 'current-menu-item active' );
			} );
		};

		const menuWorker = menu => {
			const scrollTopMiddleLine = $webSiteMainWrapper[0].scrollTop + window.innerHeight / 2;
			const activeFinded = [];

			for ( let { $linkParent, $section } of menu ) {
				let { top, bottom } = $section[0].getBoundingClientRect();
				top = $webSiteMainWrapper[0].scrollTop + top;
				bottom = $webSiteMainWrapper[0].scrollTop + bottom;

				if ( debug )
				{console.table( {top, scrollTopMiddleLine, bottom} );}

				if ( scrollTopMiddleLine > top && scrollTopMiddleLine < bottom )
				{activeFinded.push( $linkParent );}
			}

			clearActiveElementAll();

			activeFinded.forEach( $linkParent => $linkParent.addClass( 'current-menu-item active' ) );
		};
		// Tools ---

		if ( window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
			// desktop
			let header; let menu;

			if ( $headerMenuLinks )
			{header = [...fillMenus( $headerMenuLinks )];}

			if ( $mainMenuLinks )
			{menu = [...fillMenus( $mainMenuLinks )];}

			controllableMenu = [...header, ...menu];
		} else {
			// mobile
			controllableMenu = fillMenus( $mainMenuLinks );
		}

		clearActiveElementAll();
		$( 'footer li' ).removeClass( 'current-menu-item' );
		$webSiteMainWrapper.on( 'scroll', app.debounce( () => menuWorker( controllableMenu ), 10 ) );
	},
	initScrollbars: function( $scrollbars, options ) {
		setTimeout( function() {
			$scrollbars.each( ( _, scrollbar ) => {
				const $scrollbar = $( scrollbar );

				if ( $scrollbar.attr( 'data-simplebar' ) === 'init' ) {
					return;
				}

				const trackClasses = [ 'simplebar-track' ];

				if ( $scrollbar.attr( 'data-scrollbar-theme' ) === 'light' ) {
					trackClasses.push( 'simplebar-track--light' );
				}

				new SimpleBar( scrollbar, {
					classNames: {
						track: trackClasses.join( ' ' ),
					},
					...options,
				} );
			} );
		}, 1000 );
	},
	customScrollbarsForSection: function( parentElement ) {
		let $parentElement = $( parentElement );

		if ( $parentElement.find( '.scrollbar-outer' ).length ) {
			const $scrollbars = $parentElement.find( '.scrollbar-outer:not(.scroll-content)' );

			app.main.initScrollbars( $scrollbars );
		}
	},
	customScrollbarsForFormElements: function() {
		const $wrappers = $( '.list-multiselect-wrap, .textarea-wrap' );
		const $scrollbarElements = $wrappers.find( '.nf-field-element' );

		app.main.initScrollbars( $scrollbarElements );
	},
	setMultiselectSizeAttribute: function() {
		const $wrapper = $( '.list-multiselect-wrap' );
		const $multiselects = $wrapper.find( '.nf-element' );
		const isDropdownMultiselectDevice = /iPad|iPhone|iPod|Android/.test( navigator.userAgent ) || ( /Macintosh/.test( navigator.userAgent ) && navigator.maxTouchPoints > 0 );

		if ( isDropdownMultiselectDevice ) {
			$wrapper.addClass( 'is-like-dropdown' );
			return;
		}

		$multiselects.each( function() {
			const options = $( this ).find( 'option' ).length;

			$( this ).attr( 'size', options );
		} );
	},
	setTextareaHeightAttribute: function() {
		const $textareas = $( '.textarea-wrap .nf-element' );

		$textareas.each( function() {
			const $textarea = $( this );

			// Set initial height
			adjustHeight( $textarea );

			// Adjust height when content changes
			$textarea.on( 'input', function() {
				adjustHeight( $textarea );

				// Adjust height when content changes
				$textarea.on( 'input', function() {
					adjustHeight( $textarea );
				} );

				// Adjust the height on resize
				$( window ).on( 'resize', function() {
					adjustHeight( $textarea );
				} );
			} );

			// Adjust the height on resize
			$( window ).on( 'resize', function() {
				adjustHeight( $textarea );
			} );
		} );

		// Function to adjust textarea height based on content
		function adjustHeight( $el ) {
			$el.css( 'height', 'auto' );
			$el.css( 'height', $el.prop( 'scrollHeight' ) + 'px' );
		}
	},
	initFontAdjustment: function( parentElement ) {
		let $fontAdjustElem = $( parentElement ).find( '.js-font-adjustment' );
		if ( $fontAdjustElem.length ) {
			$fontAdjustElem.each( function() {
				app.main.adjustFont( this );
			} );
		}
	},
	modalGalleryDefault: function() {
		if ( $( '.modal-gallery-default' ).length ) {
			$( '.modal-gallery-default' ).each( function() {
				let $modal = $( this );

				$modal.on( 'show.bs.modal', function( e ) {
					let $sliderModalGallery = $modal.find( '.js-modal-gallery' );
					let $slides = $sliderModalGallery.find( '.swiper-slide' );
					let $relatedTargetLink = $( e.relatedTarget );
					let relatedSlideIndex = $relatedTargetLink.parents( '.swiper-slide' ).index();
					let loop = true;

					if ( $slides.length <= 1 ) {
						loop = false;
					}

					const loadSlider = () => {
						let swiperModalGallery = new Swiper( $sliderModalGallery[0], {
							slidesPerView: 1,
							speed: 1000,
							spaceBetween: 0,
							loop: loop,
							loopedSlides: 10,
							loopAdditionalSlides: 10,
							normalizeSlideIndex: false,
							effect: 'fade',
							fadeEffect: {
								crossFade: true,
							},
							navigation: {
								nextEl: $sliderModalGallery.parents( '.modal-gallery' ).find( '.swiper-button-next' )[0],
								prevEl: $sliderModalGallery.parents( '.modal-gallery' ).find( '.swiper-button-prev' )[0],
							},
							pagination: {
								el: $sliderModalGallery.parents( '.modal-gallery' ).find( '.swiper-pagination' )[0],
								type: 'fraction',
							},
							on: {
								init: function() {
									this.slideTo( relatedSlideIndex );
								}
							}
						} );

						$modal.on( 'hidden.bs.modal', function() {
							swiperModalGallery.destroy( true, true );
						} );
					};

					window.app.loadVendor( 'Swiper', loadSlider );
				} );

			} );
		}
	},
	globalSmoothScrollToBlock: function() {
		function linkEvent( event ) {
			const pageUrl = new URL( window.location.href );
			let linkUrl;

			if ( $( this ).attr( 'data-toggle' ) === 'modal' || $( this ).attr( 'data-toggle' ) === 'collapse' || $( this ).attr( 'data-toggle' ) === 'tab' || $( this ).attr( 'data-toggle' ) === 'pill' )
			{return;}

			if ( $( this ).attr( 'data-hashActive' ) === 'process' )
			{return;}

			try {
				linkUrl = new URL( $( this ).attr( 'href' ), pageUrl.origin );
			} catch ( error ) { // eslint-disable-line no-unused-vars
				event.preventDefault();
				linkUrl = $( this ).attr( 'href' );
				locationHash = window.app.clear.hash( linkUrl );
				hashMover();
			}

			linkEventHelper( pageUrl, linkUrl );
		}

		function linkEventHelper( pageUrl, linkUrl ) {
			if ( window.app.clear.path( pageUrl.pathname ) === window.app.clear.path( linkUrl.pathname ) ) {
				if ( linkUrl.hash ) {
					event.preventDefault();
					locationHash = window.app.clear.hash( linkUrl.hash );
					hashMover();
				}
			} else {
				if ( linkUrl.hash ) {
					locationHash = window.app.clear.hash( linkUrl.hash );
					const hashBlock = $( locationHash );

					if ( hashBlock.length ) {
						event.preventDefault();
						hashMover();
					}
				}
			}
		}

		$( 'body .wp-site-blocks a' ).each( function() {
			const link = $( this ).attr( 'href' );

			if ( !link || ( $( this ).attr( 'data-toggle' ) && $( this ).attr( 'data-toggle' ).match( /modal|tab|collapse|pill/ ) ) ) {
				return;
			}

			if ( link.indexOf( '#' ) !== -1 && link.length > 1 ) {
				$( this ).on( 'click', linkEvent );
			}
		} );
	},
	jobApplicationLoadFileHandler: function() {
		$( '#job-application' ).on( 'shown.bs.modal', function() {
			if ( !$( '#job-application' ).attr( 'data-init-modal-observe' ) ) {
				let fileLoadField = $( '#job-application .file_upload-container .files_uploaded' )[0];
				let config = {
					childList: true,
				};

				let fileLoadObserver = new MutationObserver( ( mutation ) => {
					if ( mutation[0].addedNodes.length ) {
						$( '#job-application .file_upload-container .nf-fu-fileinput-button span' ).text( 'Replace Resume' );
						$( '#job-application .file_upload-container .nf-fu-fileinput-button' ).addClass( 'file-loaded' );
					} else {
						$( '#job-application .file_upload-container .nf-fu-fileinput-button span' ).text( 'Add Resume' );
						$( '#job-application .file_upload-container .nf-fu-fileinput-button' ).removeClass( 'file-loaded' );
					}
				} );

				fileLoadObserver.observe( fileLoadField, config );
				$( '#job-application' ).attr( 'data-init-modal-observe', 'true' );
			} else {
				return;
			}
		} );
	},
	disableScrollRestoration: function() {
		if ( 'scrollRestoration' in history ) {
			history.scrollRestoration = 'manual';
		}
	},
	horizontalScroll: function( parentElement ) {
		if ( !$.fn.hScroll ) {
			// horizontal scroll
			$.fn.hScroll = function( amount ) {
				const $target = $( this );
				amount = amount || 120;
				function horizontalScroll( event ) {
					event.preventDefault();

					const originalEvent = event.originalEvent;
					const direction = originalEvent.detail ? originalEvent.detail * -amount : originalEvent.wheelDelta;
					let position = $target.scrollLeft();

					position += direction > 0 ? -amount : amount;

					$target.scrollLeft( position );
				}

				$target.off( 'DOMMouseScroll mousewheel' );

				if ( $target[0].scrollWidth > $target[0].clientWidth ) {
					$target.on( 'DOMMouseScroll mousewheel', horizontalScroll );
				}
			};
		}

		if ( parentElement ) {
			$( parentElement ).find( '.js-horizontal-scroll' ).each( function() {
				$( this ).hScroll( 60 );
			} );
		}
	},
	modalFormHashes: function() {
		if ( $( '.js-modal-form' ).length ) {
			$( '.js-modal-form' ).on( 'show.bs.modal', function() {
				let $modal = $( this );
				let modalHash = '#' + $modal.attr( 'id' );
				history.replaceState( '', document.title, window.location.pathname + modalHash );
			} );

			$( '.js-modal-form' ).on( 'hidden.bs.modal', function() {
				if ( !window.location.hash.match( /#thank-you/ ) ) {
					app.main.revertHistoryState();
				}
			} );
		}
	},
	revertHistoryState: function() {
		history.replaceState( '', document.title, window.location.pathname );
	},
	nfScrollBehaviour: function() {
		$( document ).on( 'nfFormReady' , function() {
			if ( typeof Marionette !== 'undefined' ) {
				var CustomFieldController = Marionette.Object.extend( {
					initialize: function() {
						this.listenTo( nfRadio.channel( 'fields' ), 'before:submit', this.checkErrors );
						nfRadio.channel( 'submit' ).reply( 'focus:firstInvalidInput', this.focusFirstInvalidInput );
					},
					checkErrors: async function( model ) {
						const formId = model.get( 'formID' );

						const errorsObject = document.getElementById( 'nf-form-' + formId + '-cont' ).querySelector( '.nf-fail' );
						if ( !errorsObject ) {
							let formChannel = nfRadio.channel( 'form-' + formId );
							formChannel.request( 'remove:error', 'field-errors' );
						}
					},

					focusFirstInvalidInput: function() {
					},
				} );

				new CustomFieldController();
			}
		} );
	},
	nfSubscribeForm: function() {
		$( document ).on( 'nfFormReady' , function() {
			if ( typeof Marionette !== 'undefined' ) {
				$( '.one-field-form' ).each( function() {
					const formID = $( this ).attr( 'id' ).match( /[1-9_]+/ )[0];
					const $formContainer = $( `#nf-form-${ formID }-cont` );

					if ( $formContainer.hasClass( '.footer-email-custom' ) )
					{return;}

					const $inputs = $formContainer.find( 'input:not(input[type="button"])' );

					const NewslettersFormExtend = Marionette.Object.extend( {
						initialize() {
							this.subscribeForm = Backbone.Radio.channel( 'form-' + formID );
							this.subscribeForm.reply( 'maybe:submit', this.beforeSubmit, this, formID );

							$inputs.keypress( event => {
								if ( event.which === 10 || event.which === 13 )
								{this.subscribeForm.request( 'maybe:submit', formID );}
							} );
						},

						beforeSubmit( formObject ) {
							const formModel = nfRadio.channel( 'app' ).request( 'get:form', formObject );

							if ( formModel.getExtra( 'formIsOk' ) ) {
								const $subButton = $formContainer.find( 'input[type="submit"]' );
								const $buttonID = $subButton.attr( 'id' );

								$formContainer.find( `#${ $buttonID }-wrap .nf-field-element` ).addClass( 'nf-field-element-loading' );
								this.subscribeForm.request( 'add:extra', 'formIsOk', false );

								return true;
							}

							this.trySubmit( formModel );
							return false;
						},

						trySubmit( formModel ) {
							if ( !formModel.get( 'errors' ).length ) {
								this.subscribeForm.request( 'add:extra', 'formIsOk', true );
								this.subscribeForm.request( 'submit', formModel );
							}
						}
					} );

					new NewslettersFormExtend();
				} );

			}
		} );
	},
	nfModalSuccess: function() {
		let hiddenCssClass = 'nf-response-msg--hidden';
		let successPopup = $( '#modal-success-popup' );

		$( '.nf-response-msg' ).addClass( hiddenCssClass );

		const handleModalClose = () => {
			app.main.revertHistoryState();
		};

		successPopup.on( 'hidden.bs.modal', handleModalClose );

		$( document ).on( 'nfFormSubmitResponse', function( event, response ) {
			let errorPopup = $( '#modal-error-popup' );
			let otherPopups = $( '.modal.show:not(#modal-success-popup)' );

			// Reinitialize form functions after submission
			app.main.setMultiselectSizeAttribute();
			app.main.setTextareaHeightAttribute();
			app.main.customScrollbarsForFormElements();

			const getErrorMessage = () => {
				const firstErrorKey = Object.keys( response.response.errors?.fields )[0];
				let errorMessage = response.response.errors?.fields[ firstErrorKey ];

				if ( typeof errorMessage === 'object' ) {
					const fieldName = $( '#nf-label-field-' + firstErrorKey ).clone()
						.children()
						.remove()
						.end()
						.text()
						.trim();

					errorMessage = fieldName + ': ' + errorMessage.message;
				}

				if ( typeof errorMessage === 'string' ) {
					if ( errorMessage.includes( 'CleanTalk' ) ) {
						errorMessage = errorPopup.find( '.text-content' ).attr( 'data-cleantalk' );
					}
				}

				return errorMessage;
			};

			const showHandleErrorPopups = ( errorMessage ) => {
				if ( otherPopups.length ) {
					otherPopups.modal( 'hide' );
					errorPopup.find( '.text-content' ).html( errorMessage );
					setTimeout( function() { errorPopup.modal( 'show' ); }, 150 );
				} else {
					errorPopup.find( '.text-content' ).html( errorMessage );
					errorPopup.modal( 'show' );
				}
			};

			const handleError = () => {
				if ( errorPopup.length ) {
					event.preventDefault();
					clearFileFields( response.response.data?.form_id );
					removeFormErrors();
					showHandleErrorPopups( getErrorMessage() );

				}
			};

			const clearFileFields = ( formId ) => {
				let $formContainer = $( '#nf-form-' + formId + '-cont' );
				$formContainer.find( '.delete' ).trigger( 'click' );
				$formContainer.find( 'input[type="file"]' ).val( '' );

			};

			const showHandleSuccessPopups = () => {
				if ( successPopup.length ) {
					if ( otherPopups.length ) {
						otherPopups.modal( 'hide' );
						successPopup.find( '.text-content' ).html( response.response.data.actions.success_message );
						setTimeout( function() { successPopup.modal( 'show' ); }, 150 );
					} else {
						successPopup.find( '.text-content' ).html( response.response.data.actions.success_message );
						successPopup.modal( 'show' );
					}
				}
			};

			const handleSuccess = () => {
				if ( typeof response.response.data.actions.redirect === 'undefined' ) {
					addHashOnSuccess( response.response.data?.form_id );
				}

				if ( typeof mainSettings.disable_forms_success_popup !== 'undefined' && mainSettings.disable_forms_success_popup.includes( response.id.replace( /_.*/, '' ) ) ) {
					const $form = $( '#nf-form-' + response.id + '-cont' );

					$form
						.find( '.nf-response-msg' )
						.removeClass( hiddenCssClass );

					$form
						.closest( '.modal' )
						.on( 'hidden.bs.modal', handleModalClose );

					return;
				}

				if ( typeof response.response.data.actions.success_message === 'undefined' ) {
					return;
				}

				event.preventDefault();
				showHandleSuccessPopups();
			};

			const addHashOnSuccess = ( formId ) => {
				let formTitle = nfRadio.channel( `form-${formId}` ).request( 'get:form' ).get( 'title' );
				let hash = '#thank-you';

				if ( !formTitle ) {
					return;
				}

				hash = hash + '-' + app.main.slugify( formTitle );

				history.replaceState( null, document.title, location.pathname + location.search + hash );
			};

			const removeFormErrors = () => {
				let nfErrorsCSSClass = 'nf-form-errors';

				let forms = $( '.' + nfErrorsCSSClass );

				if ( !forms ) {
					return;
				}

				forms.each( function() {
					let formId = $( this ).attr( 'id' ).replace( nfErrorsCSSClass + '-', '' );

					if ( !formId ) {
						return;
					}

					const formFields = nfRadio.channel( `form-${formId}` ).request( 'get:form' ).get( 'fields' );

					if ( !formFields ) {
						return;
					}

					formFields.models.forEach( fieldModel => {
						if ( fieldModel.get( 'errors' ).length ) {
							nfRadio.channel( 'fields' ).request( 'remove:error', fieldModel.get( 'id' ), 'required-error' );
						}
					} );
				} );
			};

			if ( Object.keys( response.response.errors ).length ) {
				handleError();
				return;
			}

			handleSuccess();
		} );
	},
	disableAutofill: function() {
		if ( $( '.woocommerce-page' ).length ) {
			return;
		}

		const disableInputsAutofill = () => {
			function replaceValue() {
				const $this = $( this );

				if ( $this.is( ':checkbox' ) || $this.is( ':radio' ) ) {
					return;
				}

				const val = $this.val();
				$this.off( 'change' );
				$this.val( $this.val().replace( 'o', 'о' ).replace( 'а', 'a' ).replace( 'x', 'х' ) + '\u0020' );
				$this.blur();
				setTimeout( () => {
					$this.val( val );
					$this.on( 'change', replaceHandler );
				}, 0 );
			}

			function replaceValueSelect() {
				const val = $( this ).val();
				$( this ).off( 'change' );
				const tempOption = $( this ).find( `option[value]:not(first-child):not([value="${val}"])` );
				const tempValue = $( tempOption[1] ).val();
				// console.log('select', this, $(tempOption[1]).val(), tempValue);
				$( this ).val( tempValue );
				$( this ).blur();
				setTimeout( () => {
					$( this ).val( val );
					$( this ).on( 'change', replaceHandler );
				}, 0 );
			}

			function replaceHandler() {
				const $this = $( this );

				if ( $this.is( 'select[multiple]' ) ) {
					return;
				}

				if ( $this.is( 'select' ) ) {
					replaceValueSelect.apply( this );
				} else {
					replaceValue.apply( this );
				}
			}

			$( 'input:not([type=file], [name="s"]):not(.qty),select' ).off( 'change' ).on( 'change', replaceHandler );
		};

		if ( typeof Marionette !== 'undefined' ) {
			const nfDisableAutofill = Marionette.Object.extend( {
				initialize() {
					this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.initAction );
				},

				initAction: disableInputsAutofill,
			} );
			new nfDisableAutofill();
		} else {
			disableInputsAutofill();
		}
	},
	adjustFont: function( el ) {
		let maxTitleLength;
		let fj = el.dataset.fjMin;
		let fjSizeFactor = +el.dataset.fjSizeFactor || 2;
		let titles = el.querySelectorAll( '.js-font-title' );
		if ( titles.length ) {
			maxTitleLength = getTitleMaxLength( titles );
			new FontAdjustment( {
				el: titles,
				rem: true,
				maxTitleLength,
				fj,
				fjSizeFactor,
			} );
		}

		function getTitleMaxLength( titles ) {
			let maxLength = 0;
			titles.forEach( title => {
				let titleLength = title.innerText.trim().length;
				if ( titleLength > maxLength ) {
					maxLength = titleLength;
				}
			} );

			return maxLength;
		}
	},
	adminSidebarResizer: function() {
		if ( !document.body.classList.contains( 'wp-admin' ) ) {return;}


		const siteEditor = document.querySelector( '#site-editor' );
		const editor = document.querySelector( '#editor' );
		let complementaryArea;

		if ( siteEditor ) {
			const sidebar = getSidebar();

			if ( sidebar ) {
				complementaryArea = getComplementaryArea( sidebar );
				createSidebarResizer( sidebar );
			}

			const siteEditorObserver = new MutationObserver( ( mutationRecords ) => {
				Array.from( mutationRecords ).forEach( ( record ) => {
					if ( checkObserverType( record, 'editor-header__settings' ) ) {
						handleSettingsButtonAttachment();
					}

					if ( document.querySelector( '.sidebar-resizer' ) ) {
						return;
					}

					if ( checkObserverType( record, 'interface-interface-skeleton__sidebar' ) ) {
						handleSidebarAttachment();
					}
				} );
			} );

			siteEditorObserver.observe( siteEditor, {childList: true, subtree: true} );
		} else if ( editor ) {
			const sidebar = getSidebar();
			if ( !sidebar ) {return;}

			let sidebarResizer;
			complementaryArea = getComplementaryArea( sidebar );
			setComplementaryAreaWidth( complementaryArea );

			if ( complementaryArea ) {
				sidebarResizer = createSidebarResizer( sidebar );
			}

			const settingsButton = getSettingsButton();

			settingsButton.addEventListener( 'click', () => {
				const sidebarObserver = new MutationObserver( ( mutationRecords ) => {
					handleSidebarObserver( mutationRecords, 'interface-complementary-area__fill', true );
				} );

				sidebarObserver.observe( sidebar, {childList: true, subtree: false} );
			} );

			const sidebarObserver = new MutationObserver( ( mutationRecords ) => {
				handleSidebarObserver( mutationRecords );
			} );

			sidebarObserver.observe( sidebar, {childList: true, subtree: false} );

			/**
			 * Handle the sidebar observer.
			 *
			 * @param {MutationRecord[]} mutationRecords - The mutation records.
			 * @param {string} className - The class name to check.
			 * @param {boolean} disconnect - Whether to disconnect the observer.
			 * @returns {void}
			 */
			const handleSidebarObserver = ( mutationRecords, className = 'interface-complementary-area', disconnect = false ) => {
				Array.from( mutationRecords ).forEach( ( record ) => {
					if ( record.type === 'childList' ) {
						if ( Array.from( record.addedNodes ).find( ( item ) => item.classList.contains( className ) ) ) {
							complementaryArea = getComplementaryArea( sidebar );

							if ( sidebarResizer ) {
								sidebarResizer.style.display = 'block';
							} else {
								sidebarResizer = createSidebarResizer( sidebar );
							}
						} else if ( Array.from( record.removedNodes ).find( ( item ) => item.classList.contains( className ) ) ) {
							if ( sidebarResizer ) {
								sidebarResizer.style.display = 'none';
							}
						}
					}
				} );

				if ( disconnect ) {
					sidebarObserver.disconnect();
				}
			};
		} else {
			setTimeout( () => {
				app.main.adminSidebarResizer();
			}, 1000 );
		}

		function createSidebarResizer( sidebar ) {
			if ( !sidebar ) {return;}

			const sidebarResizer = document.createElement( 'button' );
			sidebarResizer.className = 'sidebar-resizer';
			sidebarResizer.addEventListener( 'pointerdown', initResizeEl, false );
			sidebar.appendChild( sidebarResizer );

			return sidebarResizer;
		}

		function initResizeEl() {
			$( 'body' ).addClass( 'is-resizing' );
			window.addEventListener( 'pointermove', resizeEl, false );
			window.addEventListener( 'pointerup', stopResizeEl, false );
		}

		function stopResizeEl() {
			$( 'body' ).removeClass( 'is-resizing' );
			window.removeEventListener( 'pointermove', resizeEl, false );
			window.removeEventListener( 'pointerup', stopResizeEl, false );
		}

		function resizeEl( event ) {
			complementaryArea.style.width = document.documentElement.clientWidth - event.pageX + 'px';
		}

		/**
		 * Handle the settings button click.
		 *
		 * @param {HTMLElement} settingsButton - The settings button element.
		 * @returns {void}
		 */
		function handleSettingsButtonClick( settingsButton ) {
			if ( !settingsButton ) {
				return;
			}

			settingsButton.addEventListener( 'click', () => {
				const siteEditorObserver = new MutationObserver( ( mutationRecords ) => {
					Array.from( mutationRecords ).forEach( ( record ) => {
						if ( !checkObserverType( record, 'interface-interface-skeleton__sidebar' ) ) {
							return;
						}

						const sidebar = getSidebar();

						if ( !sidebar ) {
							return;
						}

						complementaryArea = getComplementaryArea( sidebar );
						siteEditorObserver.disconnect();
					} );
				} );

				siteEditorObserver.observe( siteEditor, {childList: true, subtree: true} );
			} );
		}

		function getSidebar() {
			return document.querySelector( '.interface-interface-skeleton__sidebar' );
		}

		/**
		 * Get the settings button element.
		 *
		 * @returns {HTMLElement} The settings button element.
		 */
		function getSettingsButton() {
			return document.querySelector( '[aria-controls="edit-post:document"]' );
		}

		function getComplementaryArea( sidebar ) {
			if ( sidebar ) {
				return sidebar.querySelector( '.interface-complementary-area' );
			}
		}

		function setComplementaryAreaWidth( element ) {
			if ( element && element.style ) {
				element.style.width = null;
			}
		}

		/**
		 * Check if the mutation record type and target class name are correct.
		 *
		 * @param {MutationRecord} record - The mutation record.
		 * @param {string} className - The class name to check.
		 * @returns {boolean} True if the record type and target class name are correct, false otherwise.
		 */
		function checkObserverType( record, className ) {
			return record.type === 'childList' &&
					record.target &&
					record.target.classList.contains( className );
		}

		/**
		 * Handle the settings button attachment.
		 *
		 * @returns {void}
		 */
		function handleSettingsButtonAttachment() {
			const settingsButton = getSettingsButton();

			if ( !settingsButton ) {
				return;
			}

			handleSettingsButtonClick( settingsButton );
		}

		/**
		 * Handle the sidebar attachment.
		 *
		 * @returns {void}
		 */
		function handleSidebarAttachment() {
			const sidebar = getSidebar();

			if ( !sidebar ) {
				return;
			}

			complementaryArea = getComplementaryArea( sidebar );
			setComplementaryAreaWidth( complementaryArea );
			createSidebarResizer( sidebar );
		}
	},
	submodalLogic: function() {
		setTimeout( () => {
			const openModalDelay = 500;

			$( '.js-open-submodal' ).on( 'click', function( e ) {
				e.preventDefault();

				const currentModalID = $( this ).closest( '.modal' ).attr( 'id' );
				const targetModalID = $( this ).attr( 'href' );

				$( `#${currentModalID}` ).modal( 'hide' );
				setTimeout( () => {
					$( targetModalID ).modal( 'show' );
				}, openModalDelay );
			} );
		}, 0 );
	},
};

/**
 * Scripts for admin (gutenberg) only.
 */
app.admin = function() {
	let adminSidebarResizerTimeoutId;

	setTimeout( () => {
		app.main.loadLazyLoadedVideos();
		app.main.initVideoPopups();
		app.main.resizeDependent();
		app.main.modalGalleryDefault();
		app.main.disableScrollRestoration();
		app.main.jobApplicationLoadFileHandler();
		app.main.modalFormHashes();
		app.main.addButtonStyle();
	}, 500 );

	window.addEventListener( 'load', loadHandler );

	adminSidebarResizerTimeoutId = setTimeout( () => {
		window.removeEventListener( 'load', loadHandler );

		app.main.adminSidebarResizer();
	}, 5000 );

	function loadHandler() {
		if ( adminSidebarResizerTimeoutId ) {clearTimeout( adminSidebarResizerTimeoutId );}

		app.main.adminSidebarResizer();
	}
};

/**
 * Scripts for front page.
 */
app.front = function() {
	window.loadDelayedCSS();
	app.main.successfullInitPage();
	app.main.locationHashCheck();
	app.main.loadLazyLoadedVideos();
	app.main.nonClickableSpans();
	app.main.initVideoPopups();
	app.main.parentStylesAdd();
	app.main.dynamicHashMenu();
	app.main.setMultiselectSizeAttribute();
	app.main.setTextareaHeightAttribute();
	app.main.customScrollbarsForFormElements();
	app.main.resizeDependent();
	app.main.modalGalleryDefault();
	app.main.globalSmoothScrollToBlock();
	app.main.jobApplicationLoadFileHandler();
	app.main.modalFormHashes();
	app.main.nfSubscribeForm();
	app.main.nfScrollBehaviour();
	app.main.disableAutofill();
	app.main.submodalLogic();
	app.main.showModalFormEvent();
	app.main.selectFormModalOption();

	// Listen for form reinitialization
	$( document ).on( 'nfFormReady', function() {
		app.main.setMultiselectSizeAttribute();
		app.main.setTextareaHeightAttribute();
		app.main.customScrollbarsForFormElements();
	} );

	setTimeout( app.main.nfModalSuccess, 2000 );

	// This code block always will be in the end!
	app.main.hideFocusOnDesktop();
};

app.swiperPaginationHelper = function( $swiperNavigation, onlyControls ) {
	let $navigation = $swiperNavigation;

	if ( onlyControls ) {
		$navigation = $swiperNavigation.find( '.swiper-controls--fraction' );
	}

	$navigation.show();

	if ( $swiperNavigation.find( '.swiper-button-lock' ).length > 1 ) {
		$navigation.hide();
	}
};

app.debounce = ( fn, timeout = 300 ) => {
	let timer;
	return function( ...args ) {
		if ( timer ) {
			clearTimeout( timer );
		}

		timer = setTimeout( () => {
			fn.apply( this, args );
		}, timeout );
	};
};

app.loadVendor = loadVendor;
app.loadBlock = loadBlock;
